export default function Summary(props) {
  const {t, totalExpense, averageExpense } = props;

  return (
      <div className="flex flex-col justify-center items-center my-4">
        <div className="my-2">
          <p>{t("totalExpenses")}: {totalExpense.toFixed(2)}</p>
          <p>{t("averageExpense")}: {averageExpense.toFixed(2)}</p>
        </div>
      </div>
  );
}
